import { Button } from '@/components/ui/Button'
import { ApiError } from '@/api/errors'

import styles from './ErrorState.module.css'

interface ErrorStateProps {
  error: unknown
  onRetry?: () => void
  title?: string
  description?: string
}

/** The one place an error turns into something a person can read. */
export function ErrorState({
  error,
  onRetry,
  title = 'Es ist ein Fehler aufgetreten',
  description,
}: ErrorStateProps) {
  const apiError = ApiError.from(error)

  return (
    <div className={styles.wrapper} role="alert">
      <span className={styles.icon} aria-hidden="true">
        !
      </span>
      <p className={styles.title}>{apiError.isNetworkError ? 'Keine Verbindung' : title}</p>
      <p className={styles.description}>{description ?? apiError.message}</p>
      {onRetry && (
        <div className={styles.actions}>
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Erneut versuchen
          </Button>
        </div>
      )}
    </div>
  )
}
